import { combineReducers } from "redux";
import { gasMarket } from './productReducers';

export default combineReducers({
    gasMarket
});